export default "__VITE_ASSET__BvUKpbmS__"